<onyx-modal
  variant="right"
  [heading]="swap()?.identifier"
  [loading]="loading()"
  [(error)]="error"
  [close$]="close$"
  (errorChange)="swap$.next()"
  (closeModal)="dialogRef.close()"
>
  <onyx-icon
    titleLeftOptions
    class="f-muted"
    name="exchange-filled"
    [size]="20"
  ></onyx-icon>

  <ng-container headingButtons>
    @if (isDouble()) {
      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="map-view-outlined"
        [circle]="true"
        onyxTooltip="labels.showOnMap"
        [onyxDropdownOptions]="showOnMapOptions()"
        (onyxDropdownSelectedValueChange)="$event.value?.()"
        (click)="$event.stopPropagation()"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="gantt-outlined"
        [circle]="true"
        onyxTooltip="labels.showOnGantt"
        [onyxDropdownOptions]="showOnGanttOptions()"
        (onyxDropdownSelectedValueChange)="$event.value?.()"
        (click)="$event.stopPropagation()"
      ></onyx-icon-button>
    } @else {
      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="map-view-outlined"
        [circle]="true"
        onyxTooltip="labels.showOnMap"
        (click)="showOnMap()"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="gantt-outlined"
        [circle]="true"
        onyxTooltip="labels.showOnGantt"
        (click)="showOnGantt()"
      ></onyx-icon-button>
    }

    <onyx-icon-button
      variant="transparent"
      color="gray"
      [size]="32"
      icon="share-outlined"
      [circle]="true"
      onyxTooltip="labels.share"
      (click)="share()"
    ></onyx-icon-button>

    <onyx-icon-button
      variant="transparent"
      color="gray"
      [size]="32"
      icon="options-vertical-filled"
      [circle]="true"
      [onyxDropdownOptions]="options()"
      [onyxDropdownDisabled]="!options().length"
      (onyxDropdownSelectedValueChange)="$event.value?.()"
      onyxTooltip="labels.options"
      (click)="$event.stopPropagation()"
    ></onyx-icon-button>
  </ng-container>

  <ng-container description>
    @if (swap(); as swap) {
      <onyx-address
        [address]="swap.address"
        format="full"
        [showFlag]="false"
      ></onyx-address>
    }
  </ng-container>

  <section>
    @if (swap(); as swap) {
      <div class="container">
        <onyx-chips
          [chips]="sections()"
          variant="tertiary"
          [single]="true"
          [wrap]="true"
          [gap]="8"
          [(activeValues)]="section"
        ></onyx-chips>

        @switch (section()[0]) {
          @case (SwapModalSection.SUMMARY) {
            <app-swap-modal-summary
              [swap]="swap"
              [technicalPoints]="technicalPoints()"
              [isDouble]="isDouble()"
            ></app-swap-modal-summary>
          }
          @case (SwapModalSection.ROUTE) {
            <app-swap-modal-route
              [swap]="swap"
              [isDouble]="isDouble()"
            ></app-swap-modal-route>
          }
          @case (SwapModalSection.DRIVER_REPORT) {
            <app-swap-modal-driver-report
              [technicalPoints]="technicalPoints()"
              [isDouble]="isDouble()"
              [isRecorded]="swap.isRecorded"
            ></app-swap-modal-driver-report>
          }
          @case (SwapModalSection.NOTE) {
            <app-swap-modal-note
              [swap]="swap"
              [isDouble]="isDouble()"
            ></app-swap-modal-note>
          }
        }
      </div>
    }
  </section>
</onyx-modal>
